import "./TermsAndConditions.module.css";
import Header from "@/reusable_sections/Header";
import TermsAndConditionsContent from "./sections/TermsAndConditionsContent";
import Footer from "@/reusable_sections/Footer";
export default function TermsAndConditionsPage() {
  return <div>
      <Header />
      <TermsAndConditionsContent />
      <Footer />
    </div>;
}